import React from 'react'
import { ReactComponent as ContractHolder } from '../../../../resources/images/contract-holder.svg'
import { ReactComponent as ContractContact } from '../../../../resources/images/contract-contact.svg'
import BarChartIcon from '@material-ui/icons/BarChart'
import BuildRoundedIcon from '@material-ui/icons/Build'
import { contractsDetailsStyles } from './contracts-details.styles'

export const CONTRACT_DETAILS_BLOCKS = [
  {
    id: 'miContrato',
    gridProps: { xs: 12, md: 6 },
    icon: ContractHolder,
    titleKey: 'pages.contracts.details.panel1.title',
    dataPath: '',
    fields: [
      {
        key: 'cups',
        translationKey: 'pages.contracts.details.panel1.cups',
        type: 'sensitive',
        fallback: '--',
      },
      {
        key: 'full_name',
        translationKey: 'pages.contracts.details.panel1.nombre_apellidos',
        type: 'text',
        fallback: 'pagador',
      },
      {
        key: 'nif',
        translationKey: 'pages.contracts.details.panel1.nif',
        type: 'sensitive',
        fallback: 'contrato',
      },
      {
        key: 'direccion_suministro',
        translationKey: 'pages.contracts.details.panel1.direccion_suministro',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'fecha_alta_contrato',
        translationKey: 'pages.contracts.details.panel1.fecha_alta',
        type: 'date',
        fallback: '--',
      },
      {
        key: 'fecha_baja_contrato',
        translationKey: 'pages.contracts.details.panel1.fecha_baja',
        type: 'date',
        fallback: '--',
      },
      {
        key: 'forma_pago',
        translationKey: 'pages.contracts.details.panel1.forma_pago',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'iban',
        translationKey: 'pages.contracts.details.panel1.iban',
        type: 'sensitive',
        fallback: '--',
      },
      {
        key: 'factura_digital',
        translationKey: 'pages.contracts.details.panel1.factura_digital',
        type: 'boolean',
        fallback: '--',
      },
    ],
    landingLink: {
      url: 'https://www.gnredesglp.es/glp-inicio-2/glp-contacto/formulario-de-contacto/',
      translationKey: 'pages.contracts.details.panel1.enlace_landing',
    },
  },
  {
    id: 'misDatosContacto',
    gridProps: { xs: 12, md: 6 },
    icon: ContractContact,
    titleKey: 'pages.contracts.details.panel2.title',
    dataPath: '',
    fields: [
      {
        key: 'telefono1',
        translationKey: 'pages.contracts.details.panel2.telefono1',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'telefono2',
        translationKey: 'pages.contracts.details.panel2.telefono2',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'email',
        translationKey: 'pages.contracts.details.panel2.email',
        type: 'lowercase',
        fallback: '--',
      },
      {
        key: 'idioma_para_las_comunicaciones',
        translationKey: 'pages.contracts.details.panel2.idioma',
        type: 'text',
        fallback: 'CASTELLANO',
      },
      {
        key: 'direccion_correspondencia',
        translationKey: 'pages.contracts.details.panel2.direccion_correspondencia',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'acepto_cesion',
        translationKey: 'pages.contracts.details.panel2.acepta_cesion',
        type: 'boolean',
        fallback: '--',
      },
      {
        key: 'acepto_publicidad',
        translationKey: 'pages.contracts.details.panel2.acepta_publicidad',
        type: 'boolean',
        fallback: '--',
      },
    ],
    landingLink: {
      url: 'https://www.gnredesglp.es/glp-inicio-2/glp-contacto/formulario-de-contacto/',
      translationKey: 'pages.contracts.details.panel1.enlace_landing',
    },
  },
  {
    id: 'miInstalacion',
    gridProps: { xs: 12, md: 6 },
    icon: BarChartIcon,
    iconStyle: contractsDetailsStyles.barChartIcon,
    titleKey: 'pages.contracts.details.panel3.title',
    dataPath: '',
    fields: [
      {
        key: 'n_de_contador',
        translationKey: 'pages.contracts.details.panel3.contador_numero',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'ubicacion_del_contador',
        translationKey: 'pages.contracts.details.panel3.contador_ubicacion',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'propiedad_del_contador',
        translationKey: 'pages.contracts.details.panel3.contador_propiedad',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'fecha_instalacion_del_contador',
        translationKey: 'pages.contracts.details.panel3.contador_fecha_instalacion',
        type: 'date',
        fallback: '--',
      },
      {
        key: 'fecha_primera_puesta_en_servicio',
        translationKey: 'pages.contracts.details.panel3.contador_fecha_primera_puesta',
        type: 'date',
        fallback: '--',
      },
      {
        key: 'fecha_ultima_puesta_en_servicio',
        translationKey: 'pages.contracts.details.panel3.contador_fecha_ultima_puesta',
        type: 'date',
        fallback: '--',
      },
      {
        key: 'resultado',
        translationKey: 'pages.contracts.details.panel3.inspeccion_resultado',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'fecha_ultima_visita',
        translationKey: 'pages.contracts.details.panel3.inspeccion_fecha',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'anyo_vigencia',
        translationKey: 'pages.contracts.details.panel3.inspeccion_vigencia',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'situacion_del_servicio',
        translationKey: 'pages.contracts.details.panel3.servicio_situacion',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'fecha_situacion_del_servicio',
        translationKey: 'pages.contracts.details.panel3.servicio_fecha_situacion',
        type: 'date',
        fallback: '--',
      },
      {
        key: 'canon_irc',
        translationKey: 'pages.contracts.details.panel3.canon_irc',
        type: 'boolean',
        fallback: '--',
      },
    ],
  },
  {
    id: 'misConsumos',
    gridProps: { xs: 12, md: 6 },
    icon: BuildRoundedIcon,
    iconStyle: contractsDetailsStyles.buildIcon,
    titleKey: 'pages.contracts.details.panel4.title',
    dataPath: '',
    fields: [
      {
        key: 'ultima_lectura',
        translationKey: 'pages.contracts.details.panel4.lectura_ultima',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'fecha_ultima_lectura',
        translationKey: 'pages.contracts.details.panel4.lectura_fecha',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'tipo_ultima_lectura',
        translationKey: 'pages.contracts.details.panel4.lectura_tipo',
        type: 'text',
        fallback: '--',
      },
      {
        key: 'fecha_proxima_lectura',
        translationKey: 'pages.contracts.details.panel4.lectura_proxima',
        type: 'text',
        fallback: '--',
      },
    ],
    landingLink: {
      url: 'https://www.gnredesglp.es/glp-inicio-2/clientes/lectura/',
      translationKey: 'pages.contracts.details.panel4.enlace_qr',
    },
  },
]

/* export const INSPECTION_BLOCK = {
  id: 'datosInspeccion',
  gridProps: { xs: 12 },
  titleKey: 'pages.contracts.details.panel5.title',
  dataPath: '',
  fields: [
    {
      key: 'ultima_inspeccion',
      translationKey: 'pages.contracts.details.panel5.ultima_inspeccion',
      type: 'text',
      fallback: '--',
    },
    {
      key: 'proxima_inspeccion',
      translationKey: 'pages.contracts.details.panel5.proxima_inspeccion',
      type: 'text',
      fallback: '--',
    },
  ],
} */
